import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { thunk } from 'redux-thunk';
import usersReducer from './users/reducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['users'],
};

const rootReducer = combineReducers({ users: usersReducer });

export const persistedReducer = persistReducer(persistConfig, rootReducer);

export const getStore = () => {
  const store = configureStore({
    reducer: persistedReducer,
    // middleware: [thunk],
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'], // Ignore persist actions
        },
      }).concat(thunk),
  });
  const persistor = persistStore(store);

  return { store, persistor };
};
